import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_PORTFOLIO_ANALYSIS_API =
  'INVESTMENT/FETCH_PORTFOLIO_ANALYSIS_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PORTFOLIO_ANALYSIS_API,
  ({ user_id }) => ({
    endpoint: `/api/admin/portfolios/${user_id}/analysis`,
    method: 'GET',
  })
);

export default apiCall;
